<template>
    <b-modal
            :modal-class="`message-box message-box-${modal.type}`"
            :visible="modal.show"
            :centered=true
            :hide-header=true
            :hide-footer=true
            @hidden="closeModal"
    >
        <i class="material-icons close" @click="closeModal">clear</i>
        <i class="material-icons icon">report</i>

        <div class="message-box-text d-flex flex-column text-md-left pt-3 pt-md-0 pl-md-2">
            <span v-if="modal.type === 'success'">Éxito</span>
            <span v-else>Advertencia</span>
            <small>{{ modal.message }}</small>
        </div>
    </b-modal>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import { CLOSE_MODAL } from "@/store/modules/ui/types";
    export default {
        name: 'MessageBox',
        data() {
          return {
          }
        },
        computed: {
            ...mapState('ui', ['modal'])
        },
        methods: {
            ...mapMutations('ui', [CLOSE_MODAL]),
            closeModal() {
                this.$store.commit('ui/' + CLOSE_MODAL);
            }
        }
    }
</script>
